import {Customer, StaticNotification, StaticNotificationType} from "../../util/types";
import Icon from "./Icon";
import {Link} from "react-router-dom";
import {staticNotificationMap} from "../../util/staticNotificationMap";
import Routing from "../../Routing.ts";

export default function OverviewStaticNotifications({customer}: { customer: Customer }) {

    const staticNotifications = customer
        .customer_context
        .notifications
        .map(
            (notification: StaticNotification): StaticNotificationType => ({
                payload: notification.payload,
                ...staticNotificationMap[notification.type]
            })
        );

    return <section className="selfcare-overview-messages-container">
        <h2 className={'heading heading--big'}>
            Beskeder og genveje
        </h2>

        {staticNotifications.length === 0
            ? <p>Der er ingen nye beskeder at vise</p>
            : <OverviewNotificationList staticNotifications={staticNotifications}/>
        }

    </section>
}

function OverviewNotificationList({staticNotifications}: { staticNotifications: StaticNotificationType[] }) {

    const sortedNotifications = staticNotifications.sort(function (x, y) {
        return (x.important === y.important) ? 0 : x.important ? -1 : 1;
    });

    return <ul className="selfcare-overview-messages">
        {sortedNotifications.map((staticNotification, index) =>
            <OverviewNotification key={index} staticNotificationType={staticNotification}/>
        )}
    </ul>
}

function OverviewNotification({staticNotificationType}: { staticNotificationType: StaticNotificationType }) {
    const importantClass = staticNotificationType.important ? ' selfcare-overview-message--important' : '';
    const linkClass = staticNotificationType.link ? '' : ' no-link';
    const additionalClassName = staticNotificationType.className ? ` ${staticNotificationType.className}` : '';

    return <li className={`selfcare-overview-message${importantClass}${linkClass}${additionalClassName}`}>
        {staticNotificationType.element ? staticNotificationType.element(staticNotificationType.payload) : <LinkNotification staticNotificationType={staticNotificationType}/>}
    </li>
}


function LinkNotification({staticNotificationType}: { staticNotificationType: StaticNotificationType }) {

    return staticNotificationType.link ?
    <Link to={staticNotificationType.link} state={{from_url: Routing.Selfcare.Index}}>
        <Icon component={staticNotificationType.icon}/>
        <span className="text">
            {staticNotificationType.title(staticNotificationType.payload)}
        </span>
    </Link>
    :
    <>
        <Icon component={staticNotificationType.icon}/>
        <span className="text">
            {staticNotificationType.title(staticNotificationType.payload)}
        </span>
    </>
}
